import { Slide, ToastOptions, TypeOptions, toast } from "react-toastify"
import { v4 as uuidv4 } from "uuid"

export class Notifier {
  private defaultOptions: ToastOptions

  constructor(options?: ToastOptions) {
    this.defaultOptions = {
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      transition: Slide,
      position: "top-center",
      theme: "light",
      icon: false,
      className: "z-[999]",
      closeButton: false,
      progressStyle: {
        transformOrigin: "right",
      },
      ...options,
    }
  }

  notify(message: string, type: TypeOptions, options?: ToastOptions) {
    const toastId = uuidv4()
    toast[type](message, { ...this.defaultOptions, options, toastId })
  }

  success(message: string, options?: ToastOptions) {
    this.notify(message, "success")
  }

  error(message: string, options?: ToastOptions) {
    this.notify(message, "error", options)
  }

  warning(message: string, options?: ToastOptions) {
    this.notify(message, "warning", options)
  }

  info(message: string, options?: ToastOptions) {
    this.notify(message, "info", options)
  }
}
